<template>
  <div class="web-box-all" id="map_0">
    <ext-header ref="ExtHomeHeader" select_menu="1"></ext-header>
    <div class="web-home-main">
      <div class="web-home-adv">
        <ext-adv></ext-adv>
      </div>
    </div>

    <div style="width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;" v-for="(vo,index) in recommend_goods_list" :key="index" >
      <div class="web-home-main" :id="['map_'+(index+1)]">
        <div class="web-home-title">
          <a></a>
          <p>{{vo.title}}<i></i></p>
          <a></a>
          <b @click="get_recommend_more(vo.id)">查看更多>></b>
        </div>
      </div>
      <div class="web-goods-main">
        <div class="web-home-goods">
          <div v-for="(voo,keys) in vo.list" :key="keys" :class="[voo.select==1 ? 'web-home-goods-list active' : 'web-home-goods-list']" v-on:mouseover="changeActive(keys,'recommend_goods_list',index)" v-on:mouseout="removeActive(keys,'recommend_goods_list',index)">
            <div :class="[voo.select==1 ? 'web-home-goods-list-data active' : 'web-home-goods-list-data']">
              <a @click="get_goods_show(voo.goods_no)">
                <img src="@/assets/goods_load.png" v-real-img="web_url+voo.goods_image">
                <p>
                  <i>¥</i><b>{{voo.goods_money}}</b>
                </p>
                <h2>{{voo.goods_name}}</h2>
                <h3>{{voo.goods_no}}</h3>
              </a>
              <h4>
                <b class="del" @click="goods_del(index,keys)">-</b>
                <b class="num">
                  <input type="number" v-model.number="voo.qty" oninput="if(value.length>3)value=value.slice(0,3)" />
                </b>
                <b class="add" @click="goods_add(index,keys)">+</b>
                <b class="cart" @click="add_cart(index,keys,voo.goods_no)">
                  <img src="@/assets/icon/cart01.png"/>
                </b>
                <b class="collect" @click="set_collect(index,keys,voo.goods_no)">
                  <img v-if="voo.collect_state==1" src="@/assets/icon/love01.png"/>
                  <img v-else src="@/assets/icon/love02.png"/>
                </b>
              </h4>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="web-home-main"  id="map_3" v-if="company_no=='MCD-CHN' || company_no=='MCD-AUS'">
      <div class="web-home-title">
        <a></a>
        <p>促销活动<i></i></p>
        <a></a>
      </div>
      <div class="web-home-activity">
        <div v-for="(vo,index) in home_activity_list" :key="index" class="web-home-activity-list" @click="get_activity_list(vo.id)">
          <img src="@/assets/avc_load.png" v-real-img="web_url+vo.image">
        </div>
      </div>
    </div>

    <div class="web-home-main" id="map_4" v-if="company_no=='MCD-CHN' || company_no=='MCD-AUS'">
      <div class="web-home-title">
        <a></a>
        <p>产品分区<i></i></p>
        <a></a>
      </div>
      <div class="web-home-product">
        <div v-for="(vo,index) in home_product_list" :key="index" class="web-home-product-list" @click="get_product_list(vo.id)">
          <img src="@/assets/avc_load.png" v-real-img="web_url+vo.image">
        </div>
      </div>
    </div>

    <div class="web-home-line"></div>

    <ext-footer ref="ExtHomeFooter"></ext-footer>

    <ext-leftnav v-if="company_no=='MCD-CHN'"></ext-leftnav>

    <ext-toast :style="toast_state" :toast_text="toast_text"></ext-toast>

  </div>
</template>
<script>
import ExtHomeHeader from '@/components/header/home'
import ExtHomeFooter from '@/components/footer/home'
import ExtAdv from '@/components/carousel/index'
import leftnav from '@/components/leftnav/leftnav'
import {getUserId, ajax, Encrypt, Decrypt, webUrl, getCompanyNo} from '@/utils/extend'
import Toast from '@/components/toast/index'

export default {
  name: 'home',
  components: {
    'ext-header': ExtHomeHeader,
    'ext-footer': ExtHomeFooter,
    'ext-adv': ExtAdv,
    'ext-leftnav': leftnav,
    'ext-toast': Toast
  },
  data () {
    return {
      title: '首页',
      web_url: webUrl(),
      company_no: getCompanyNo(),
      recommend_goods_list: [],
      hot_goods_list: [],
      home_activity_list: [],
      home_product_list: [],
      toast_state: 'display:none',
      toast_text: ''
    }
  },
  mounted () {
    this.load_data()
  },
  methods: {
    toast (msg) {
      var that = this
      that.toast_state = 'display:block'
      that.toast_text = msg
      setTimeout(function () {
        that.toast_text = ''
        that.toast_state = 'display:none'
      }, 1500)
    },
    changeActive (index, list, fid) {
      this.$set(this['' + list][fid].list[index], 'select', '1')
    },
    removeActive (index, list, fid) {
      this.$set(this['' + list][fid].list[index], 'select', '0')
    },
    get_recommend_more (id) {
      this.$router.push({path: '/activity/recommend_goods', query: {v: Encrypt(id)}})
    },
    get_goods_show (goodsNo) {
      // let routeData = this.$router.resolve({path: '/goods/goods_show', query: {v: Encrypt(goodsNo)}})
      // window.open(routeData.href, '_blank')
      this.$router.push({path: '/goods/goods_show', query: {v: Encrypt(goodsNo)}})
    },
    get_activity_list (id) {
      this.$router.push({path: '/activity/activity_show', query: {v: Encrypt(id)}})
    },
    get_product_list (id) {
      this.$router.push({path: '/activity/activity_show', query: {v: Encrypt(id)}})
    },
    goods_add (index, key) {
      var listdata = this.recommend_goods_list
      var qty = listdata[index].list[key].qty ? listdata[index].list[key].qty : 1
      if (qty < 999) {
        qty = parseInt(qty) + 1
      } else {
        qty = 999
      }
      this.$set(this.recommend_goods_list[index].list[key], 'qty', qty)
    },
    goods_del (index, key) {
      var listdata = this.recommend_goods_list
      var qty = listdata[index].list[key].qty ? listdata[index].list[key].qty : 1
      if (qty > 1) {
        qty = parseInt(qty) - 1
      } else {
        qty = 1
      }
      this.$set(this.recommend_goods_list[index].list[key], 'qty', qty)
    },
    set_collect (index, key, goodsNo) {
      var listdata = this.recommend_goods_list
      var state = listdata[index].list[key].collect_state ? listdata[index].list[key].collect_state : 0
      var goodsId = listdata[index].list[key].goods_id
      var that = this
      if (state === '1') {
        this.$set(this.recommend_goods_list[index].list[key], 'collect_state', '0')
        ajax({
          url: '/store/goods/goods_collect',
          method: 'post',
          data: {
            uid: getUserId(),
            goods_id: goodsId,
            collect_type: 2
          }
        }, function (ret) {
          that.$refs.ExtHomeFooter.get_cart_count()
        })
      } else {
        this.$set(this.recommend_goods_list[index].list[key], 'collect_state', '1')
        ajax({
          url: '/store/goods/goods_collect',
          method: 'post',
          data: {
            uid: getUserId(),
            goods_id: goodsId,
            collect_type: 1
          }
        }, function (ret) {
          that.$refs.ExtHomeFooter.get_cart_count()
        })
      }
    },
    add_cart (index, key, goodsNo) {
      var that = this
      var listdata = this.recommend_goods_list
      var qty = listdata[index].list[key].qty ? listdata[index].list[key].qty : 1

      ajax({
        url: '/store/order/add_cart',
        method: 'post',
        data: {
          uid: getUserId(),
          type_id: 1,
          type_add: 'add',
          goods_no: goodsNo,
          qty: qty
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.toast(ret.msg)
          that.$refs.ExtHomeHeader.load_cart_list()
          that.$refs.ExtHomeFooter.get_cart_count()
        } else {
          that.toast(ret.msg)
        }
      })
    },
    load_data () {
      var that = this

      that.recommend_goods_list = []
      ajax({
        url: '/store/home/recommend_goods_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.recommend_goods_list = ret.data
        } else {
          that.recommend_goods_list = []
        }
      })

      that.home_activity_list = []
      ajax({
        url: '/store/home/home_activity_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.home_activity_list = ret.data
        } else {
          that.home_activity_list = []
        }
      })

      that.home_product_list = []
      ajax({
        url: '/store/home/home_product_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.home_product_list = ret.data
        } else {
          that.home_product_list = []
        }
      })
    }
  }
}

</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}

.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1200px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-goods-main { width:1225px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
  .web-home-adv { width:950px; height:auto; margin-left:250px;}

.web-home-title { width:100%; height:50px; position: relative; flex-flow:row; justify-content:center; display: flex; margin-top:15px;}
  .web-home-title a { width:100px; height:10px; background: url('https://parts.franke.cn/static/image/line001.png') repeat-x; margin-top:22px; flex:1;}
  .web-home-title p { width:auto; padding:0px 15px; position: relative; box-sizing: border-box; height:50px; line-height: 50px; font-size:24px; color:#333333; text-align: center; justify-content:center;}
  .web-home-title p i { width:24px; height:1px; border-top:3px solid #d81e06; position: absolute; bottom:0px; left:50%; margin-left:-12px;}
  .web-home-title b { width:80px; cursor: pointer; height:50px; text-align: right; font-weight: normal; line-height:50px; font-size:12px; background: #ffffff; color:#666666; position: absolute; right: 0px; top:0px;}

.web-home-goods { width:100%; height:auto; margin-top:10px; display: flex; flex-flow:row; align-content:flex-start; flex-wrap:wrap;}
  .web-home-goods-list { width:245px; height:410px; margin:5px 0px; padding:10px; border:1px solid #ffffff;}
  .web-home-goods-list.active { border:1px solid #d81e06;}
  .web-home-goods-list-data { width:223px; height:390px; cursor: pointer; position: relative; border:1px solid #e7e7e7; flex-wrap:wrap; align-content:flex-start;}
  .web-home-goods-list-data a {width:223px; height:auto; flex-wrap:wrap; align-content:flex-start; }
  .web-home-goods-list-data.active { border:1px solid #ffffff;}
  .web-home-goods-list-data img { width:100%; height:230px; padding:10px 10px 0px 10px;}
  .web-home-goods-list-data h2 { width:223px; height:40px; line-height:20px; word-break:break-all; margin:5px 0px; font-size:14px; color:#333333; padding:0px 10px;}
  .web-home-goods-list-data h3 { width:223px; height:20px; line-height:20px; margin:0px; font-size:12px; color:#333333; padding:0px 10px;}
  .web-home-goods-list-data p { width:223px; height:40px; padding:0px 10px; margin:0px; flex-flow:row; align-content:flex-start;}
  .web-home-goods-list-data p i { font-size:12px; margin-right:5px; margin-top:10px; font-style:normal; color:#d81e06;}
  .web-home-goods-list-data p b { font-size:22px; color:#d81e06;}

  .web-home-goods-list-data h4 { width:223px; height:40px; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; position: absolute; left:0px; bottom: 5px; z-index: 99; margin:0px; padding:0px 10px; flex-flow:row; align-content:flex-start;}
  .web-home-goods-list-data h4 b { font-size:14px; line-height:30px; float:left; font-weight: normal;}
  .web-home-goods-list-data h4 b.del { width:30px; height:30px; cursor: pointer; line-height:25px; text-align: center; color:#666666; font-size:20px; border:1px solid #e7e7e7;}
  .web-home-goods-list-data h4 b.num { width:44px; height:30px; overflow: hidden; border-top:1px solid #e7e7e7; border-bottom:1px solid #e7e7e7;}
  .web-home-goods-list-data h4 b.num input { width:44px; height:20px; margin-top:5px; text-align: center; line-height:20px; font-size:12px; color:#333333; min-height:20px; border:0px;}
  .web-home-goods-list-data h4 b.add { width:30px; height:30px; cursor: pointer; line-height:25px; text-align: center; color:#666666; font-size:20px; border:1px solid #e7e7e7;}
  .web-home-goods-list-data h4 b.cart { width:30px; height:30px; cursor: pointer; margin-left:22px; text-align: center; border-radius: 3px;  line-height:30px; background: #fff; font-size:13px; color:#ffffff;}
  .web-home-goods-list-data h4 b.cart img { width:26px; height:26px; padding:0px; box-sizing: border-box; }
  .web-home-goods-list-data h4 b.collect { width:30px; height:30px; cursor: pointer; margin-left:8px; text-align: center; border-radius: 3px; line-height:30px; background: #fff; font-size:13px; color:#ffffff;}
  .web-home-goods-list-data h4 b.collect img { width:26px; height:26px; padding:0px; box-sizing: border-box; }

  .web-home-activity { width:100%; height:auto; display: flex; flex-flow:row; justify-content:space-between; align-content:flex-start; flex-wrap:wrap;}
    .web-home-activity-list{ width:590px; min-height:308px; cursor: pointer; margin-top:15px; position: relative; flex-wrap:wrap; align-content:flex-start;}
    .web-home-activity-list img { width:590px; min-height:268px; object-fit: cover;}
    .web-home-activity-list-p { width:590px; height:40px; position: absolute; font-weight: bold; padding:0px 15px; background: rgba(0,0,0,0.3); left:0px; bottom:-15px; line-height: 40px; font-size:14px; color:#ffffff; }
    .web-home-activity-list p { width:590px; height:37px; margin-top:16px; font-weight: bold; line-height: 27px; font-size:16px; color:#333333; }

  .web-home-product { width:100%; height:auto; display: flex; flex-flow:row; justify-content:space-between; align-content:flex-start; flex-wrap:wrap;}
    .web-home-product-list{ width:290px; min-height:154px; cursor: pointer; margin-top:15px; position: relative; flex-wrap:wrap; align-content:flex-start;}
    .web-home-product-list img { width:290px; min-height:134px; object-fit: cover;}
    .web-home-product-list-p { width:290px; height:40px; position: absolute; font-weight: bold; padding:0px 15px; background: rgba(0,0,0,0.3); left:0px; bottom:-15px; line-height: 40px; font-size:14px; color:#ffffff; }
    .web-home-product-list p { width:290px; height:37px; margin-top:16px; font-weight: bold; line-height: 27px; font-size:16px; color:#333333; }

.web-home-line { width:100%; height:70px; }
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue